const s = {
  name: "QAndA",
  dimensions: { width: 40, height: 40 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 40" style="enable-background:new 0 0 40 40;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M20,14c-1.7,0-3,1.3-3,3h-2c0-2.8,2.2-5,5-5s5,2.2,5,5c0,2.4-1.7,4.4-4,4.9V24h-2v-4h1c1.7,0,3-1.3,3-3
			S21.7,14,20,14z"/>
		<path class="st0" d="M21.3,27c0,0.7-0.6,1.2-1.2,1.2c-0.7,0-1.2-0.6-1.2-1.2c0-0.7,0.6-1.2,1.2-1.2C20.7,25.7,21.3,26.3,21.3,27z"
			/>
		<path class="st0" d="M0,20C0,9,9,0,20,0s20,9,20,20c0,11-9,20-20,20c-4.1,0-7.8-1.2-11-3.3l-8.6,2.9L3.3,31C1.2,27.8,0,24.1,0,20z
			 M20,2C10.1,2,2,10.1,2,20c0,3.8,1.2,7.3,3.2,10.2l0.3,0.4l-1.9,5.8l5.8-1.9l0.4,0.3c2.9,2,6.4,3.2,10.2,3.2c9.9,0,18-8.1,18-18
			S29.9,2,20,2z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as QAndA
};
